import utils from '@/mixins/utils.js'
import { getQuantidadeExodontias } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @returns {Object}
 */
export function getDataFields(mes = null) {
  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    Exodontias: {
      callback: (item) => {
        return getQuantidadeExodontias(item, mes)
      },
    },
  }
}

export const infoHtml = ``
